import React from "react";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { dismissNotice } from "actions";
import "./style.scss";

/**
 * Gets the height to allow the notification to be inserted
 * @param {Node} node
 * @returns {Number}
 */
export const getTransitionHeight = (node) => {
  const notification = node;
  const notificationStyles = window.getComputedStyle(notification);

  const animationHeight = parseInt(notificationStyles.getPropertyValue("margin-top").replace(/[a-zA-Z]/gi, ""), 10) +
    parseInt(notificationStyles.getPropertyValue("margin-bottom").replace(/[a-zA-Z]/gi, ""), 10) +
    notification.getBoundingClientRect().height;

  return animationHeight;
};

export class ModalNotification extends React.Component {
  /** @param {Object} props */
  constructor(props) {
    super(props);
    this.state = {
      closedModal: false,
      transitionHeight: 0
    };
    const { notices, noticeName } = this.props;
    this.onCloseNotice = this.onCloseNotice.bind(this);
    this.inputRef = React.createRef();
    // we only want to set this once when first created
    this.noticeIsVisible = notices.getIn([noticeName, "isVisible"]);
  }

  /** @param {Event} e */
  onCloseNotice(e) {
    e.preventDefault();
    this.setState({
      closedModal: true,
      transitionHeight: getTransitionHeight(this.inputRef.current)
    });
  }

  /**
   * Render method to create notifications
   * @returns {html} rendered view
   */
  render() {
    const {
      children,
      noticeName,
      renderNotice,
      dismissNoticeAction
    } = this.props;

    const { closedModal, transitionHeight } = this.state;

    return (
      <>
        {this.noticeIsVisible && (
          <div className="ModalNotification" ref={this.inputRef}>
            {renderNotice({ onClose: this.onCloseNotice })}
          </div>
        )}

        <div
          className={classNames({ "SettingsPlatformsZendeskModal--modalClosed": closedModal })}
          style={
            closedModal
              ? {
                transform: `translateY(-${transitionHeight}px)`,
                marginBottom: `-${transitionHeight}px`
              }
              : null
          }
          onTransitionEnd={(e) => {
            // need this check because this event will bubble up from children
            if (e.target === e.currentTarget) {
              dismissNoticeAction(noticeName);
            }
          }}
        >
          {children}
        </div>
      </>
    );
  }
}

ModalNotification.defaultProps = {
};

ModalNotification.propTypes = {
  renderNotice: PropTypes.func.isRequired,
  notices: ImmutablePropTypes.mapOf(ImmutablePropTypes.record).isRequired,
  noticeName: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  dismissNoticeAction: PropTypes.func.isRequired
};

/** @param {Object} state
  * @returns {Object }
  */
function mapState(state) {
  const { notices } = state;

  return {
    notices
  };
}

/** @param {Function} dispatch
  * @returns {Object}
  */
function mapDispatch(dispatch) {
  return bindActionCreators({ dismissNoticeAction: dismissNotice }, dispatch);
}

const Connector = connect(
  mapState,
  mapDispatch
)(ModalNotification);

export default Connector;
